module.exports = __webpack_public_path__ + "static/media/435_Bedroom1.b9d51070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Bedroom1.jpg
// module id = 553
// module chunks = 0